const unredeemed_pawns_chart_data = (data) => {
  return {
    datasets: [
      {
        datalabels: {
          font: function (context) {
            var width = context.chart.width;
            var size = Math.round(width / 39);
            return {
              size: size,
            };
          },
          formatter: function (value, context) {
            let sum = 0;
            let dataArr = context.chart.data.datasets[0].data;
            dataArr.forEach((data) => {
              sum += data;
            });
            let percentage = ((value * 100) / sum).toFixed(0) + "%";
            return percentage;
          },
          anchor: "end",
          align: "center",
          backgroundColor: "#ced6e0",
          borderRadius: 10,
          color: "#212121",
        },
        data: data.items,
        backgroundColor: data.colors,
      },
    ],
    labels: data.items.some(x => x > 0) ? data.labels : [],
  };
};

export default unredeemed_pawns_chart_data;
